import pkg from './../package.json'

export const VERSION = pkg.version

export const IO_URL = 'https://infiniteobjects.com/'

export const SENTRY_DSN = 'https://14baa0ca71dd4ca8b526933b5a411cbe@o504622.ingest.sentry.io/6678300'
